export const allLangauges = {
  c: "c_cpp",
  cpp: "cpp",
  python: "python",
  python3: "python",
  java: "java",
  javascript: "javascript",
  kotlin: "kotlin",
  rust: "rust",
};
